import Live2Kh from "../../components/live2/kh/Live2Kh";
import {useSocket} from "../../helpers/socket";

const Live2KHPage = () => {
    const {socket} = useSocket({platform: "kh_website"});
    return <Live2Kh socket={socket}/>
}

export default Live2KHPage;